import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
  IAPI_CON021_Request,
  IAPI_CON021_Response,
  IAPI_CON022_Request,
  IAPI_CON022_Response,
} from "../../../type/apiType";

/**
 * 契約解除（共済法令違反）内容表示
 * @return httpViolationDetailsRefer
 */
const httpAPI_CON022 = async (
  param: IAPI_CON022_Request
): Promise<IAPI_CON022_Response> => {
  let res = await http.post(ApiUrl.API_CON022, {
    ...param,
  });

  return res.data;
};

/**
 * 契約解除（共済法令違反）内容更新
 * @return httpViolationDetailsUpdate
 */
const httpAPI_CON021 = async (
  param: IAPI_CON021_Request
): Promise<IAPI_CON021_Response> => {
  let res = await http.post(ApiUrl.API_CON021, {
    ...param,
  });

  return res.data;
};

/**
 * 申請状況更新
 * @return httpAPI_APP016
 */
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

export { httpAPI_CON022, httpAPI_CON021, httpAPI_APP016 };
